<template>
  <el-container class="mainView">
    <SidebarMenu :is-saas="isSaas" />
    <el-main class="main">
      <router-view></router-view>
    </el-main>
  </el-container>
</template>

<script>
import SidebarMenu from '@/components/SidebarMenu';
import { mapGetters } from 'vuex';

export default {
  name: 'MainView',
  components: {
    SidebarMenu,
  },
  computed: {
    ...mapGetters('common', ['isSaas']),
  },
};
</script>

<style lang="scss" scoped>
.mainView {
  display: flex;

  .main {
    position: relative;
    display: flex;
  }
}
</style>